export const TEAM_BASE_URL = "https://rolling-api.vercel.app/6-1/";
// NOTE - 카카오톡에 등록한 앱의 JavaScript Key
export const KAKAO_JAVASCRIPT_KEY = "9fb684e1300bd15ee0ae8a44bb82caf4";
// NOTE - 공유 시 사용할 이미지의 URL
export const SHARE_IMAGE_URL = "https://ifh.cc/g/k8zYH3.jpg";

export const ACQUAINTANCE = "지인";
export const FRIEND = "친구";
export const COWORKER = "동료";
export const FAMILY = "가족";

export const NOTO_SANS = "Noto Sans";
export const PRETENDARD = "Pretendard";
export const NANUM_MYEONGJO = "나눔명조";
export const NANUM_HANDLETTER = "나눔손글씨 손편지체";

export const ALL_POST_PAGE = "allpost";
export const POST_PAGE = "post";
export const LIST_PAGE = "list";

export const PC_MIN_WIDTH = 1249;
